import styles from '../contactus.module.scss'
import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ExecutiveCommitteeMember from './executiveCommitteeMember';
import Address from './address';
import BoardOfDirectors from './boardOfDirectors';


const ContactInfoTabComponent = () => {
    const [activeButton, setActiveButton] = useState<string | null>(null);

    const handleECMClick = () => {
        setActiveButton('ECM');
    };

    const handleAddressClick = () => {
        setActiveButton('Address');
    };
    const handleBoardofdirectorsClick = () => {
        setActiveButton('BOD');
    }
    useEffect(() => {
        setActiveButton('Address');
        window.scrollTo(0, 200); // Scroll to the top of the page
        // Find the specific heading element by its ID or class name
        const contacttab = document.getElementById('contacttab');
        if (contacttab) {
            contacttab.scrollIntoView({ behavior: 'smooth' }); // Scroll to the top
        }
    }, [])

    return (
        <>
            <div className={styles.ContactInfoTabLayout}>
                <Typography className={styles.typoGraphyHeading}>Contact Info</Typography>
                <div style={{ marginTop: "20px" }}>
                    <div className={styles.buttonContainer}>
                        <Button
                            onClick={handleAddressClick}
                            className={activeButton === 'Address' ? `${styles.activeButton}` : ''}
                        >
                            <span style={{ textTransform: 'none' }}>Address</span>
                        </Button>
                        <Button
                            onClick={handleECMClick}
                            className={activeButton === 'ECM' ? `${styles.activeButton}` : ''}
                        >
                            <span style={{ textTransform: 'none' }}>Executive Committee Members</span>
                        </Button>
                        <Button
                            onClick={handleBoardofdirectorsClick}
                            className={activeButton === 'BOD' ? `${styles.activeButton}` : ''}><span style={{ textTransform: 'none' }}>Board Of Directors</span></Button>
                    </div>
                </div>
                <div style={{ borderBottom: '2px solid #D4E2EA' }}></div>
            </div>
            {activeButton === 'Address' && <Address />}
            {activeButton === 'ECM' && <ExecutiveCommitteeMember />}
            {activeButton === 'BOD' && <BoardOfDirectors/>}
        </>
    )
}

export default ContactInfoTabComponent;

